import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { Pagination } from 'ui/pagination';
import { usePaginationContext } from 'utils/contexts/pagination';
import { MessageTypeSchema } from 'modules/frequencyManagement/contexts/FormProvider';
import { Body2LightNoMargin } from 'modules/frequencyManagement/components/Content.styles';

export const Wrapper = styled.div`
  align-items: center;
  border-top: solid 1px ${colors.borderPrimary};
  display: flex;
  justify-content: space-between;
  padding: ${spacing.threeQuarter} ${spacing.plusHalf};
  width: 100%;
`;

export const CardFooter = ({ messageTypes }: { messageTypes: MessageTypeSchema[] }) => {
  const { currentPage, pageSize, setCurrentPage } = usePaginationContext();

  return (
    <Wrapper>
      <Body2LightNoMargin>{messageTypes.length} total</Body2LightNoMargin>
      <Pagination
        page={currentPage}
        pages={Math.ceil(messageTypes.length / pageSize)}
        onChangePage={(page) => {
          setCurrentPage(page);
        }}
      />
      <div /> {/* div is only here as an easy fix to balance the spacing */}
    </Wrapper>
  );
};
